<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="log-box">
    <el-dialog :before-close="closeBox" :visible="true">
      <el-table :data="list" style="width: 100%" height="250">
        <el-table-column fixed prop="event" label="事件"> </el-table-column>
        <el-table-column prop="content" label="内容"> </el-table-column>
        <el-table-column prop="admin_name" label="操作人"> </el-table-column>
        <el-table-column prop="create_time" label="操作时间"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    logType: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      fullscreenLoading: false,
      list: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/PurchaseGroup/getLogList", { id: this.id })
        .then(res => {
          this.fullscreenLoading = false;
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.list = res.data.data;
        });
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/components/Log.vue